import React, { useState } from "react";
import styled from "styled-components";
import { MdClose, MdStar } from "react-icons/md";
import { db, auth } from "./firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

const ModalOverlay = styled.div`
  position: fixed; top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(0, 0, 0, 0.6); display: flex; align-items: center;
  justify-content: center; z-index: 10000; backdrop-filter: blur(4px);
`;

const ModalContent = styled.div`
  background: white; padding: 30px; border-radius: 20px; width: 90%; max-width: 480px;
  position: relative; box-shadow: 0 10px 25px rgba(0,0,0,0.2);
  h2 { margin: 0 0 10px; color: #1a202c; font-size: 1.5rem; font-weight: 700; text-align: center; }
  p { color: #5f6368; font-size: 0.9rem; text-align: center; margin-bottom: 20px; }
`;

const FormGroup = styled.div`
  margin-bottom: 15px;
  label { display: block; font-size: 0.85rem; font-weight: 600; color: #4a5568; margin-bottom: 5px; }
  input, textarea {
    width: 100%; padding: 12px; border: 1.5px solid #e2e8f0; border-radius: 10px;
    outline: none; font-family: inherit; transition: border-color 0.2s;
    &:focus { border-color: #1a73e8; }
  }
  textarea { height: 100px; resize: none; }
`;

const StarRatingWrapper = styled.div`
  display: flex; justify-content: center; gap: 8px; margin-bottom: 20px;
`;

const StarIcon = styled(MdStar)`
  cursor: pointer; color: ${(props) => (props.$active ? "#ecc94b" : "#e2e8f0")};
  font-size: 2.5rem; transition: transform 0.1s;
  &:hover { transform: scale(1.1); }
`;

const CloseButton = styled.div`
  position: absolute; top: 20px; right: 20px; cursor: pointer; color: #a0aec0;
  &:hover { color: #4a5568; }
`;

const SubmitBtn = styled.button`
  background-color: #1a73e8; color: white; border: none; border-radius: 12px;
  padding: 14px; font-weight: 600; cursor: pointer; width: 100%; font-size: 1rem;
  transition: background 0.2s;
  &:hover { background-color: #1557b0; }
  &:disabled { background-color: #cbd5e0; cursor: not-allowed; }
`;

const Feedback = ({ isOpen, onClose, userProfile }) => {
  const [rating, setRating] = useState(0);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async () => {
    if (rating === 0) {
      alert("Please provide a star rating!");
      return;
    }

    setLoading(true);
    try {
      await addDoc(collection(db, "feedbacks"), {
        userId: auth.currentUser?.uid || "anonymous",
        userName: userProfile?.fullName || "Guest",
        userEmail: auth.currentUser?.email || "No Email",
        rating: rating,
        message: message.trim() || "No message provided", // Message is optional
        createdAt: serverTimestamp(),
      });
      alert("Thank you for your valuable feedback!");
      setRating(0);
      setMessage("");
      onClose();
    } catch (error) {
      console.error("Error saving feedback:", error);
      alert("Error submitting feedback. Please try again.");
    }
    setLoading(false);
  };

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <CloseButton onClick={onClose}><MdClose size={24} /></CloseButton>
        <h2>Your Feedback</h2>
        <p>How would you rate your experience with us?</p>

        <StarRatingWrapper>
          {[1, 2, 3, 4, 5].map((star) => (
            <StarIcon
              key={star}
              $active={star <= rating}
              onClick={() => setRating(star)}
            />
          ))}
        </StarRatingWrapper>

        <FormGroup>
          <label>Name</label>
          <input type="text" value={userProfile?.fullName || ""} disabled />
        </FormGroup>

        <FormGroup>
          <label>Email Address</label>
          <input type="email" value={auth.currentUser?.email || ""} disabled />
        </FormGroup>

        <FormGroup>
          <label>Message (Optional)</label>
          <textarea
            placeholder="Tell us more about your experience..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </FormGroup>

        <SubmitBtn onClick={handleSubmit} disabled={loading || rating === 0}>
          {loading ? "Submitting..." : "Send Feedback"}
        </SubmitBtn>
      </ModalContent>
    </ModalOverlay>
  );
};

export default Feedback;